import ApplicationController from 'javascript/controllers/application_controller';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends ApplicationController {
  success({ detail: [url] }) {
    Turbo.visit(url);
  }

  success_no_turbolinks({ detail: [url] }) {
    window.location = url;
  }
}
